import type { UUID } from '@aline/common';

export interface ProgressTask {
  id: UUID;
  completedAt?: string | null;
  parentTask?: { id: UUID } | null;
  rejectedAt?: string | null;
}

// Top-level task counts for a card. Subtasks roll up into their parent.
export function getTaskProgress(tasks: readonly ProgressTask[] = []) {
  const rootTasks = tasks.filter(task => !task.parentTask);
  const done = rootTasks.filter(task => Boolean(task.completedAt)).length;
  return { done, open: rootTasks.length - done, total: rootTasks.length };
}

/**
 * Whether a phase's work is done, by the server's rule: at least one top-level task, every
 * top-level task completed, and no sub-task still open. A rejected sub-task is closed.
 */
export function getAreAllTasksDone(tasks: readonly ProgressTask[]): boolean {
  return tasks.some(task => !task.parentTask) && tasks.every(getIsTaskClosed);
}

function getIsTaskClosed(task: ProgressTask): boolean {
  if (task.completedAt) return true;
  return Boolean(task.parentTask) && Boolean(task.rejectedAt);
}
